import { loadData, UserDataProvider } from "../../../Core/UserDataProvider"
import { tokenBody } from "../../../DataTypes/authResponse"
import { LeadsQueryParams } from "../../../DataTypes/leads"
import { ContactRequestsQueryParams, ContactRequestUpdateFields } from "../../../DataTypes/contactRequests"
import { controllers } from "../../Controllers"


class OutreachController {

    getLeads = async (params: LeadsQueryParams = {}) =>{
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.loadLeads, {userToken, ...params})
        return response
    }

    getLeadDetail = async (leadId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.getLeadDetail(leadId, body), {userToken})
        return response
    }

    addLead = async (fields: any) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.addLead, {userToken, ...fields})
        return response
    }

    editLead = async (leadId: number, fields: any) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.editLead(leadId, body), {userToken, ...fields})
        return response
    }

    updateLeadStatus = async (leadId: number, status: string) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.updateLeadStatus(leadId, body), {userToken, status})
        return response
    }

    getCategories = async (includeInactive: boolean = false) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.getLeadCategories(body, includeInactive), {userToken})
        return response
    }

    addCategory = async (fields: any) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.addLeadCategory, {userToken, ...fields})
        return response
    }

    editCategory = async (categoryId: number, fields: any) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.editLeadCategory(categoryId, body), {userToken, ...fields})
        return response
    }

    deleteCategory = async (categoryId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.deleteLeadCategory(categoryId, body), {userToken})
        return response
    }
    
    getLeadManagers = async () => {
        const tokenBody: tokenBody = { userToken: controllers().auth.userToken || "" }
        return await loadData(UserDataProvider.listLeadManagers, tokenBody)
    }
    
    
    getWorkers = async () => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getWorkers, {userToken})
        return response
    }
    
    getActivityDashboard = async (post: {start_date: any, end_date: any, gap_minutes?: number, user_id?: number}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getActivityDashboard, {userToken, ...post})
        return response
    }
    
    
    getMyEmailStats = async (post: {start_date: any, end_date: any, gap_minutes?: number, user_id?: number}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getMyEmailStats, {userToken, ...post})
        return response
    }
    
    
    getMyDashboard = async (post: {start_date: any, end_date: any, gap_minutes?: number, user_id?: number}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getMyDashboard, {userToken, ...post})
        return response
    }

    getContactRequests = async (params: ContactRequestsQueryParams = {}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getContactRequests, {userToken, ...params})
        return response
    }

    getContactRequestDetail = async (id: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getContactRequestDetail, {userToken, id})
        return response
    }

    updateContactRequest = async (id: number, fields: ContactRequestUpdateFields) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.updateContactRequest, {userToken, id, ...fields})
        return response
    }

    getNewRequestLogs = async (params: { since?: string, limit?: number } = {}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getNewRequestLogs, {userToken, ...params})
        return response
    }


}

export { OutreachController }
